import { useEffect } from 'react';

export function useAdminHotkey(callback) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            const key = (e.key || '').toLowerCase();
            
            
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && key === 'a') {
                e.preventDefault();
                callback();
            }
        };


        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [callback]);
}
